import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { NocApproverDetailModel } from "src/app/model/NocApproverDetailModel";
import { NocApproverService } from "src/app/services/noc-approver.service";
import { ViewPdfComponent } from "../view-pdf/view-pdf.component";
import { NocRejectCaseComponent } from "./reject-case/noc-reject-case.component";
import { InAppBrowser, InAppBrowserEvent, InAppBrowserOptions } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { ESignService } from "src/app/services/esign-service.service";
import { NocApproveCaseComponent } from "./approve-case/noc-approve-case.component";
import { AllotmentLetterGenerationDetailModel } from "src/app/model/AllotmentLetterGenerationDetailModel";
import { LettersService } from "src/app/services/letters.service";

@Component({
  selector: "app-secure-allotment-letter-generatation",
  templateUrl: "./allotment-letter-generatation.component.html",
  styleUrls: ["./allotment-letter-generatation.component.scss"],
})
export class AllotmentLetterGeneratation implements OnInit {
    isLoading: boolean = true;
    allotmentLetterGenerationDetail: AllotmentLetterGenerationDetailModel;
    submitDisabled: boolean;
    applicationNo: number;
    nocStatus: string;
    status:string;
    allotmentUnsignLetterSts:string;

    constructor(private router: Router, private route: ActivatedRoute, 
        private allotmentLetterService: LettersService,
        private iab: InAppBrowser,
        private esignService: ESignService,
        private modalCtrl: ModalController, private _snackBar: MatSnackBar) { }
    
    ngOnInit(): void { 
       // this.submitDisabled = false;
        this.route.params.subscribe((params: Params) => {
            this.applicationNo = +params['applicationNo'];
            this.isLoading = false;
            this.allotmentLetterService.fetchAllotmentLetterGenerationDetail(this.applicationNo)
            .subscribe(data => {
                this.allotmentLetterGenerationDetail= data;
                this.isLoading = false;
            });
        });
    }

    async reject() {
        const modal = await this.modalCtrl.create({
            component: NocRejectCaseComponent,
            componentProps: {
                pan: this.allotmentLetterGenerationDetail.applicationNo,
                applicantName: this.allotmentLetterGenerationDetail.applicantName
            }
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();
        
        // if (role === 'reject') {
        //     this.onSubmit('REJECTED', data);
        // }
    }

    // async approve() {
    //     const modal = await this.modalCtrl.create({
    //         component: NocApproveCaseComponent,
    //         componentProps: {
    //             pan: this.allotmentLetterGenerationDetail.applicationNo,
    //             applicantName: this.allotmentLetterGenerationDetail.applicantName
    //         }
    //     });
    //     modal.present();

    //     const { data, role } = await modal.onWillDismiss();
       
    // }
   
    async viewFile(fileType, file) {
        const modal = await this.modalCtrl.create({
            component: ViewPdfComponent,
                componentProps: {
                base64: file,
                documentName: fileType,
                fileName: fileType+"_"+this.allotmentLetterGenerationDetail?.applicationNo+"_"+new Date().getTime()+".pdf"
            }
        });
        modal.present();
    }

    generateLetter(){
        console.log("Selected application No", this.applicationNo);
        this.isLoading = true;
        this.allotmentLetterService.generateAllotmentLetter(this.applicationNo).subscribe((data) => {
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
              this.status = data.status;
              this.isLoading = false;
              this.allotmentLetterService.successToast("Genrated Sucessfully");
              //window.location.reload();
              this.router.navigate(['/secure', 'allotment-letter-generation-dtl', this.applicationNo, "fetch"]);
            }
            else {
              this.allotmentLetterService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.allotmentLetterService.errorToast(error?.error?.message || error?.error?.errorMessage);
            this.isLoading = false;
          }
          );
      }
     // downloadLetter
     downloadAllotmentLetter(){
        console.log("Selected application No", this.applicationNo);
        this.allotmentLetterService.getAllotmentLetterFile(this.applicationNo).subscribe((data) => {
            this.isLoading = false;
            if(data.status === 'SUCCESS') {
              this.status = data.status;
              this.allotmentLetterService.successToast(data.successMsg);
              this.isLoading = true;
              window.location.reload();
            }
            else {
              this.allotmentLetterService.errorToast(data.errorMessage);
            }
          },
          (error) => {
            this.allotmentLetterService.errorToast(error?.error?.message || error?.error?.errorMessage);
            this.isLoading = false;
          }
          );
      }

      async downloadLetter(e: number) {
        this.applicationNo = e;
        this.isLoading = true;
        this.allotmentLetterService.getAllotmentLetterFile(this.applicationNo)
        .subscribe(async (data) => {
            if(data.status === 'SUCCESS') {
                this.downloadFile(data.base64File, data.fileName);
                this.isLoading = false;
            }
            else {
                this.allotmentLetterService.errorToast(data.errorMessage);
            }
        });
      }
    
      downloadFile(base64:string | ArrayBuffer, fileName:string){
        const src = `data:text/xlsx;base64,${base64}`;
        const link = document.createElement("a")
        link.href = src
        link.download = fileName
        link.click()
        
        link.remove()
      }
}